class Constants {
    public static readonly kDaysAfterInLastMonth = 20;
    public static readonly clipTextGradient = 'bg-clip-text text-transparent bg-gradient-to-r from-violet-400 via-pink-400 to-cyan-400';
}

export default Constants;
